import { mdiFileDocumentOutline } from '@mdi/js';
import React from 'react';
import { ActionMenuBadge, IActionMenuBadgeItem } from './action-menu-badge';
import { BadgeIcon } from './badge-icon';
import { generateLabel } from './util';

export interface IClaimBadgeProps {
    className?: string;
    id?: string;
    name?: string;
    path?: string;
    tooltip?: string;
    items?: IActionMenuBadgeItem[];
}
export const ClaimBadge: React.FunctionComponent<IClaimBadgeProps> = (props: IClaimBadgeProps): React.ReactElement => {
    const { className, id, name, path, tooltip, items } = props;
    return (
        <ActionMenuBadge
            className={className}
            label={generateLabel('Claim', id, name)}
            path={path || `/claims/${id}`}
            tooltip={tooltip}
            items={items}
            Symbol={<BadgeIcon path={mdiFileDocumentOutline} />}
            id={id}
        />
    );
};
